import React from "react";
import { useHistory } from "react-router-dom";
import FormFactory from "../../../../components/form-factory";
import { theme } from "../../../../styles/theme";
import { Fields } from "./fields";
import { FiscalNoteModel } from "../../../../../domain/models/fiscal-note";

type FactoryProps = {
  fiscalNote?: any;
  developerCompaniesList: any[];
  handleAddNote: (values: any, setShowConfirm: any) => Promise<void>;
  currentNote: any,
  setCurrentNote: any,
  isToCreate: boolean;
  loadingNote: boolean;
  setIsLoadingNote?: any;
}

export const Factory = ({
  fiscalNote,
  developerCompaniesList,
  handleAddNote,
  currentNote,
  setCurrentNote,
  isToCreate,
  loadingNote,
  setIsLoadingNote,
}: FactoryProps): JSX.Element => {
  const history = useHistory();

  return (
    <FormFactory
      groups={Fields(
        fiscalNote || ({} as FiscalNoteModel),
        developerCompaniesList,
        currentNote,
        setCurrentNote,
        isToCreate,
        setIsLoadingNote,
      )}
      enbaleCountGroup
      enableReinitialize={loadingNote}
      onSubmit={handleAddNote}
      backButton={{
        submit: "Voltar",
        submitting: "Voltando...",
        hide: false,
        onClick: () => history.goBack(),
        backgroundColor: theme.colors.darkBlue,
      }}
      button={{
        submit: isToCreate ? "Nova Recorrência" : "Atualizar Recorrência",
        submitting: isToCreate ? "Criando..." : "Atualizando...",
        hide: false,
        backgroundColor: theme.colors.blue400,
      }}
    />
  );
};